import { SITE } from "../data/site";

const COLORS = ["text-volt", "text-accent-bright", "text-cyan", "text-magenta", "text-eblue", "text-gold-soft"];

export const Marquee = ({ items }) => {
  const row = (key, ariaHidden) => (
    <div key={key} aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-2xl sm:text-3xl lg:text-4xl uppercase whitespace-nowrap px-6 sm:px-10 ${COLORS[i % COLORS.length]}`}
          >
            {item}
          </span>
          <img
            src={SITE.logo}
            alt=""
            className="h-6 w-6 sm:h-8 sm:w-8 rounded-full object-cover opacity-80"
          />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden py-6 sm:py-8 border-y border-sand bg-cream"
    >
      <div className="flex w-max animate-marquee">
        {row("a", false)}
        {row("b", true)}
      </div>
    </div>
  );
};
